module.exports = __webpack_public_path__ + "static/media/Team2.30741d65.jpg";